<template v-slot:default="{ isActive }">
    <v-dialog
      v-model="dialog"
      width="60rem"
      class="layer-popup"
      scrollable
    >
      <v-card>
        <!--content-->
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="pop-title">{{ popupTitle }}</div>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click.stop="dialog = false"
          ></v-btn>
        </v-card-title>
        <!--content-->
        <v-card-text>
          <div class="dropdown-group">
            <v-list v-model:opened="listOpen">
              <!--depth1 -->
              <v-list-group v-for="(itemD1, seqD1) in filterArray(0)" :key="itemD1.idx" :value="itemD1.idx">
                <template v-slot:activator="{ props }">
                  <v-list-item v-bind="props" :class="{'on': itemD1.selected, 'hidden-icon': filterArray(itemD1.idx).length === 0}">
                    <!--  :append-icon="filterArray(itemD3.idx).length>0?'mdi-chevron-down':null" -->
                    <c-Input :placeholder="popupTitle+t('message.enterValueType2')" v-model="itemD1.treeName" :name="'treerow'" @click.stop @keydown.stop/>
                    <div class="btn-group">
                      <c-btn01 :btnText="t('message.delete')" :btn-show="true" class="sm" @click.stop.prevent="onClickDelRow(itemD1)"/>
                      <c-btnLine01 :btnText="t('message.addSub')" :btn-show="true" class="sm" @click.stop.prevent="onClickAddChild(itemD1)"/>
                    </div>
                  </v-list-item>
                </template>
                <!--depth2 -->
                <v-list-group v-for="(itemD2, seqD2) in filterArray(itemD1.idx)" :key="itemD2.idx" :value="itemD2.idx">
                  <template v-slot:activator="{ props }">
                    <v-list-item v-bind="props" :class="{'on': itemD2.selected, 'hidden-icon': filterArray(itemD2.idx).length === 0}">
                      <c-Input :placeholder="popupTitle+t('message.enterValueType2')" v-model="itemD2.treeName" :name="'treerow'" @click.stop @keydown.stop/>
                      <div class="btn-group">
                        <c-btn01 :btnText="t('message.delete')" :btn-show="true" class="sm" @click.stop.prevent="onClickDelRow(itemD2)"/>
                        <c-btnLine01 :btnText="t('message.addSub')" :btn-show="true" class="sm" @click.stop.prevent="onClickAddChild(itemD2)"/>
                      </div>
                    </v-list-item>
                  </template>
                  <!--depth3 -->
                  <v-list-group v-for="(itemD3, seqD3) in filterArray(itemD2.idx)" :key="itemD3.idx" :value="itemD3.idx">
                    <template v-slot:activator="{ props }">
                      <v-list-item v-bind="props" :class="{'on': itemD3.selected, 'hidden-icon': filterArray(itemD3.idx).length === 0}">
                        <c-Input :placeholder="popupTitle+t('message.enterValueType2')" v-model="itemD3.treeName" :name="'treerow'" @click.stop @keydown.stop/>
                        <div class="btn-group">
                          <c-btn01 :btnText="t('message.delete')" :btn-show="true" class="sm" @click.stop.prevent="onClickDelRow(itemD3)"/>
                          <c-btnLine01 :btnText="t('message.addSub')" :btn-show="true" class="sm" @click.stop.prevent="onClickAddChild(itemD3)"/>
                        </div>
                      </v-list-item>
                    </template>
                    <!--depth4-->
                    <v-list-group v-for="(itemD4, seqD4) in filterArray(itemD3.idx)" :key="itemD4.idx" :value="itemD4.idx">
                      <template v-slot:activator="{ props }">
                        <v-list-item v-bind="props" :class="{'on': itemD4.selected, 'hidden-icon': filterArray(itemD4.idx).length === 0}">
                          <c-Input :placeholder="popupTitle+t('message.enterValueType2')" v-model="itemD4.treeName" :name="'treerow'" @click.stop @keydown.stop/>
                          <div class="btn-group">
                            <c-btn01 :btnText="t('message.delete')" :btn-show="true" class="sm" @click.stop.prevent="onClickDelRow(itemD4)"/>
                            <c-btnLine01 :btnText="t('message.addSub')" :btn-show="true" class="sm" @click.stop.prevent="onClickAddChild(itemD4)"/>
                          </div>
                        </v-list-item>
                      </template>
                      <!--depth5-->
                      <v-list-group v-for="(itemD5, seqD5) in filterArray(itemD4.idx)" :key="itemD5.idx" :value="itemD5.idx">
                        <template v-slot:activator="{ props }">
                          <v-list-item v-bind="props" :class="{'on': itemD5.selected, 'hidden-icon': filterArray(itemD5.idx).length === 0}">
                            <c-Input :placeholder="popupTitle+t('message.enterValueType2')" v-model="itemD5.treeName" :name="'treerow'" @click.stop @keydown.stop/>
                            <div class="btn-group">
                              <c-btn01 :btnText="t('message.delete')" :btn-show="true" class="sm" @click.stop.prevent="onClickDelRow(itemD5)"/>
                              <c-btnLine01 :btnText="t('message.addSub')" :btn-show="true" class="sm" @click.stop.prevent="onClickAddChild(itemD5)"/>
                            </div>
                          </v-list-item>
                        </template>
                        <!--depth6-->
                        <v-list-group v-for="(itemD6, seqD6) in filterArray(itemD5.idx)" :key="itemD6.idx" :value="itemD6.idx">
                          <template v-slot:activator="{ props }">
                            <v-list-item v-bind="props" :class="{'on': itemD6.selected, 'hidden-icon': filterArray(itemD6.idx).length === 0}">
                              <c-Input :placeholder="popupTitle+t('message.enterValueType2')" v-model="itemD6.treeName" :name="'treerow'" @click.stop @keydown.stop/>
                              <div class="btn-group">
                                <c-btn01 :btnText="t('message.delete')" :btn-show="true" class="sm" @click.stop.prevent="onClickDelRow(itemD6)"/>
                              </div>
                            </v-list-item>
                          </template>
                        </v-list-group>
                        <!--depth6 -->
                      </v-list-group>
                      <!--depth5 -->
                    </v-list-group>
                    <!--depth4 -->
                  </v-list-group>
                  <!--depth3 -->
                </v-list-group>
                <!--depth2 -->
              </v-list-group>
              <!--depth1 -->
            </v-list>
          </div>
        </v-card-text>
        <!--버튼-->
        <v-card-actions class=" d-flex justify-end pop-bottom-bg">
          <c-btn02 :btnText="t('message.add')" :btn-show="true" @click.stop.prevent="onClick1DepthAddRow"/>
          <c-btn01 v-bind="btnSave" @click.prevent.stop="handleForm"/>
        </v-card-actions>
      </v-card>
      <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
    </v-dialog>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import CompanyService from "@/services/company.service";
import utils from "@/common/Utils";
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import _ from 'lodash';
import OrganizationService from "@/services/organization.service";
import * as yup from "yup";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const emit = defineEmits(['close','confirm'])
const dialog = defineModel()

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//ui
const btnSave = computed(() =>({
  btnText: t('message.save'),
}))

//bind
const snackbar = ref(false)
const snackText = ref('')
const items = ref([])
const popupTitle = ref(t('message.department'))
const listOpen = ref([])
//const groupOpen = ref(true)

//hook
onBeforeUpdate (()=>{
  items.value = []
})

onUpdated (() => {
  popupTitle.value = storeRef.popupType.value == 'dept'?t('message.department'):t('message.position')
  if (!storeRef.popupIdx.value)
    return;

  if (dialog.value) {
    let params = {idx: 0, companyIdx: storeRef.popupIdx.value, treeType: storeRef.popupType.value,}
    CompanyService.getCompanyTreeList(params).then(
      (response) => {
        items.value = response.result
        listOpen.value = getAllIdxs()
        if(response.result.length == 0) {
          let newObj = {parentIdx: 0, treeName: '', treeLevel: 1, companyIdx: storeRef.popupIdx.value, treeType: storeRef.popupType.value,}
          CompanyService.insertCompanyTree(newObj).then(
            (response) => {
              items.value.push(response.result)
            },
            (error) => {
              if(error.status == 403)
                utils.movePage('/login')
              else{
                snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
                snackbar.value = true
              }
            }
          )
        }
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
})
const filterArray = computed(()=>(param) => {return _.filter(items.value, {parentIdx: param}) })
const getAllIdxs = ()=> {return _.map(items.value, "idx")}

const onClickDelRow=(item)=>{
  const childCnt = _.filter(items.value, {parentIdx: item.idx}).length
  if(childCnt > 0){
    snackText.value = t('message.cannotDeleteDueToChildItems')
    snackbar.value = true
    return
  }

  let newObj = {idx: item.idx}
  CompanyService.deleteCompanyTree(newObj).then(
    (response) => {
      let resultArr = _.reject(items.value, item)
      items.value = resultArr
      emit('confirm', 'delete '+storeRef.popupType.value)
      /*
      let params = {idx: 0, companyIdx: storeRef.popupIdx.value, treeType: storeRef.popupType.value,}
      CompanyService.getCompanyTreeList(params).then(
        (response) => {
          items.value = response.result
        },
        (error) => {
          if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
        }
      )
       */
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const onClickAddRow=(item)=>{
  let newObj = {parentIdx: item.parentIdx, treeName: '', treeLevel: item.treeLevel, companyIdx: storeRef.popupIdx.value, treeType: storeRef.popupType.value,}
  CompanyService.insertCompanyTree(newObj).then(
    (response) => {
      let objIndex = _.findIndex(items.value, item)
      let beforeArr = _.slice(items.value, 0, objIndex+1)
      let newObject = response.result
      let postArr = _.slice(items.value, objIndex+1)
      let resultArr = _.concat(beforeArr, newObject, postArr)
      items.value = resultArr
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const onClick1DepthAddRow=()=>{
  let newObj = {parentIdx: 0, treeName: '', treeLevel: 1, companyIdx: storeRef.popupIdx.value, treeType: storeRef.popupType.value,}
  CompanyService.insertCompanyTree(newObj).then(
    (response) => {
      let newObject = response.result
      items.value.push(newObject)
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const onClickAddChild=(item)=>{
  let newObj = {parentIdx: item.idx, treeName: '', treeLevel: item.treeLevel+1, companyIdx: storeRef.popupIdx.value, treeType: storeRef.popupType.value,}
  CompanyService.insertCompanyTree(newObj).then(
    (response) => {
      let objIndex = _.findIndex(items.value, item)
      let beforeArr = _.slice(items.value, 0, objIndex+1)
      let newObject = response.result
      let postArr = _.slice(items.value, objIndex+1)
      let resultArr = _.concat(beforeArr, newObject, postArr)
      items.value = resultArr

      //추가된 row를 자동으로 펼침
      if (!listOpen.value.includes(newObject.idx)) {
        listOpen.value.push(newObject.idx)
        listOpen.value.push(item.idx)
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const handleForm=()=>{
  if(import.meta.env.MODE == 'development') {
    emit('close', '')
  }
  else{
    let companyIdx = localStorage.getItem('companyIdx')
    let params = {
      companyIdx: storeRef.popupIdx.value,
      treeType: storeRef.popupType.value,
      idx:[],
      treeName:[],
      treeLevel:[],
      parentIdx:[]
    }
    items.value.forEach(function(row) {
      params['idx'].push(row.idx)
      params['treeName'].push(row.treeName)
      params['treeLevel'].push(row.treeLevel)
      params['parentIdx'].push(row.parentIdx)
    });

    CompanyService.insertUpdateCompanyTree(params).then(
      (response) => {
        emit('confirm', 'update '+storeRef.popupType.value)
        emit('close', '')
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

const handleKeydown=(e)=> {
  if (e.code === 'Space' || e.code === 'Enter') {
    e.preventDefault()
  }
}
</script>


<style lang="scss">

</style>
